import React from "react";
import { AlertCircle, CheckCircle, AlertTriangle, Info, X } from "lucide-react";

const variantConfig = {
  error: {
    bg: "bg-error-subtle",
    border: "border-error/20",
    text: "text-error",
    Icon: AlertCircle,
  },
  success: {
    bg: "bg-success-subtle",
    border: "border-success/20",
    text: "text-success",
    Icon: CheckCircle,
  },
  warning: {
    bg: "bg-warning-subtle",
    border: "border-warning/20",
    text: "text-warning",
    Icon: AlertTriangle,
  },
  info: {
    bg: "bg-info-subtle",
    border: "border-info/20",
    text: "text-info",
    Icon: Info,
  },
};

function Message({ text, variant = "error", onDismiss, children }) {
  const config = variantConfig[variant] || variantConfig.error;
  const IconComponent = config.Icon;

  return (
    <div className={`flex items-start gap-3 p-4 rounded-sm border ${config.bg} ${config.border} animate-fade-in`}>
      <IconComponent size={18} strokeWidth={1.5} className={`${config.text} shrink-0 mt-0.5`} />
      <div className={`text-base ${config.text} flex-1 leading-snug`}>{text || children}</div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          aria-label="Sluiten"
          className="shrink-0 text-text-tertiary hover:text-text-primary transition-colors duration-fast"
        >
          <X size={16} strokeWidth={1.5} />
        </button>
      )}
    </div>
  );
}

export default Message;
